// extracted by mini-css-extract-plugin
export default {"container":"approved_container__oZOz-","artworkBox":"approved_artworkBox__1kqI-","outerBox":"approved_outerBox__nS9vq"};